import { render, staticRenderFns } from "./AddUpdateBaykedExclusiveDeal.vue?vue&type=template&id=4742f50b&scoped=true"
import script from "./AddUpdateBaykedExclusiveDeal.vue?vue&type=script&lang=js"
export * from "./AddUpdateBaykedExclusiveDeal.vue?vue&type=script&lang=js"
import style0 from "./AddUpdateBaykedExclusiveDeal.vue?vue&type=style&index=0&id=4742f50b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4742f50b",
  null
  
)

export default component.exports